$(function () {
    var metro = {
        init: function () {
            $(document).ready(function () {
                metro.handleStationClick();
                metro.handleCloseLocationModalClick();
            })
        },

        handleStationClick: function () {
            $(document).on('click', '.moscow_metro_map__station', function () {
                var id = $(this).data('id')
                var title = $(this).find('text').text()
                $(this).toggleClass('active')
                $('.moscow_metro_map__check[data-id="' + id + '"]').toggleClass('active')

                // При клике на станцию в схеме карты метро, отмечает в обычном списке станцию
                $('.filter__location-content__metro-stations-item input[data-title="' + title + '"]').prop('checked', true).change()
            })
        },

        handleCloseLocationModalClick: function () {
            $(document).on('click', '.modal_locations-menu__close', function () {
                $('#locations-modal').addClass('hidden')
                setTimeout(function() {
                    $('#locations-modal').removeClass('hidden show')
                }, 300)
                var event = new Event('closeMetroScheme')
                document.dispatchEvent(event)
            })
        },
    }

    metro.init()
})
